import type { RecordsPatientData } from '../../services/patient';

export interface RecordsPatient {
    id: string;
    name: string;
    statusLabel: string;
}

export function buildRecordsPatient(
    patientId: string,
    data: RecordsPatientData,
    fallbackStatus = 'On Hold'
): RecordsPatient {
    return {
        id: patientId,
        name: data.name ?? '',
        statusLabel: data.status?.caseStatus ?? fallbackStatus
    };
}
